<template>
  <div
    class="search-wrapper"
    :class="{ 'search-wrapper--icon': icon }"
  >
    <i
      v-if="icon"
      class="fas fa-search search-icon"
    />
    <BFormInput
      size="sm"
      class="search"
      :class="{ 'pl-4': icon }"
      :value="value"
      :placeholder="placeholder || `${$t('general.search')}...`"
      type="search"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    placeholder: String,
    icon: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
  .search-wrapper {
    position: relative;
  }

  .search {
    border-radius: 20px;
    padding-left: 15px;
  }

  .search-wrapper--icon .search-icon {
    position: absolute;
    top: 50%;
    left: 14px;
    transform: translateY(-50%);
    color: #adb5bd;
    font-size: 12px;
    pointer-events: none;
  }
</style>
